import { render, staticRenderFns } from "./equiCompsPage.vue?vue&type=template&id=1ea122e8&scoped=true&"
import script from "./equiCompsPage.vue?vue&type=script&lang=js&"
export * from "./equiCompsPage.vue?vue&type=script&lang=js&"
import style0 from "./equiCompsPage.vue?vue&type=style&index=0&id=1ea122e8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea122e8",
  null
  
)

export default component.exports